






































































import { Vue, Component, Prop } from "vue-property-decorator";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";
import ParentProductViewModel from "@/chipply/view-model/ParentProductViewModel";
import CartViewModel from "@/chipply/view-model/CartViewModel";
import ProductQuantityViewModel from "@/chipply/view-model/ProductQuantityViewModel";

@Component({})
export default class CartQuantityWarning extends Vue {
    @Prop({ type: Boolean })
    public computedCartMaxReached!: boolean;

    @Prop({ type: Object })
    public productViewModel!: ProductViewModel;

    @Prop({ type: Object })
    public parentProductViewModel!: ParentProductViewModel;

    @Prop({ type: Object })
    public cartViewModel!: CartViewModel;

    @Prop({ type: Object })
    public productQuantityViewModel!: ProductQuantityViewModel;

    @Prop({ type: Boolean })
    public packageView!: boolean;

    public getCurrentMax() {
        return this.productQuantityViewModel.calculateCurrentMax(
            this.productViewModel,
            this.parentProductViewModel,
            this.cartViewModel
        );
    }
}
